import { motion } from 'framer-motion';
import type { TechNewsItem } from '../types';
import { ExternalLink, Star } from 'lucide-react';

interface TechNewsCardProps {
  item: TechNewsItem;
  index?: number;
}

export default function TechNewsCard({ item, index = 0 }: TechNewsCardProps) {
  // 根据标签选择不同的颜色
  const getTagColor = (tag: string) => {
    if (tag.includes('深度学习')) return 'text-blue-400 bg-blue-500/20 border-blue-500/30';
    if (tag.includes('大模型')) return 'text-purple-400 bg-purple-500/20 border-purple-500/30';
    if (tag.includes('自动驾驶')) return 'text-green-400 bg-green-500/20 border-green-500/30';
    return 'text-pink-400 bg-pink-500/20 border-pink-500/30';
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      viewport={{ once: true }}
    >
      <a
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        className="block glass rounded-lg p-4 card-hover group"
      >
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2 mb-2">
              <Star size={14} className="text-yellow-400" />
              <span className={`text-xs px-2 py-0.5 rounded-full border ${getTagColor(item.tag)}`}>
                {item.tag}
              </span>
              <span className="text-xs text-pink-300/50">•</span>
              <span className="text-xs text-gray-500">{item.source}</span>
              <span className="text-xs text-pink-300/50">•</span>
              <span className="text-xs text-gray-500">{item.date}</span>
            </div>
            
            <h4 className="text-base font-medium text-white group-hover:text-pink-400 transition-colors truncate">
              {item.title}
            </h4>
            
            <p className="text-sm text-gray-400 mt-1 line-clamp-2">
              {item.summary}
            </p>
          </div>
          
          <ExternalLink
            size={16}
            className="text-gray-500 group-hover:text-pink-400 transition-colors ml-4 flex-shrink-0"
          />
        </div>
      </a>
    </motion.div>
  );
}
